var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.81,419.54c-15.15,0-30.29-2.23-45.44-5.79c-57.02-15.15-102.01-60.13-117.15-117.15 c-20.49-77.06,13.81-156.8,82.85-193.77c5.35-3.12,12.92-1.34,16.04,4.01c2.23,3.56,2.67,7.57,1.34,11.58 c-7.57,19.6-11.14,40.09-10.25,61.47c3.12,77.51,66.37,140.76,143.88,143.88c21.38,0.89,41.87-2.67,61.47-10.25 c5.35-2.23,12.03,0,15.15,5.35c2.23,3.56,2.23,8.46,0.45,12.47C387.75,385.69,330.73,419.54,268.81,419.54L268.81,419.54z  M185.07,126c-53.45,35.64-78.4,102.01-61.47,166.15c13.36,50.78,53.45,90.87,104.23,104.23c13.81,3.56,27.62,5.35,40.98,5.35 c50.78,0,97.55-25.39,125.17-66.82c-15.15,4.45-31.18,6.68-47.22,6.68l0,0c-2.23,0-4.9,0-7.57,0 c-86.42-4.01-156.8-74.39-160.8-161.25C177.94,162.08,180.17,143.81,185.07,126z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.43732fb9.svg";
export { ForwardRef as ReactComponent };